import Immutable from 'immutable'

import createPayment from '../../records/Payment'
import { RECEIVE_SIGNUPS } from './signup/constants'

// ------------------------------------
// Constants
// ------------------------------------
export const constants = {

}

// ------------------------------------
// Actions
// ------------------------------------
export const actions = {

}

// ------------------------------------
// Selectors
// ------------------------------------
export const selectors = {

}

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = Immutable.fromJS({
  payments: Immutable.Set(),
})

function buildPaymentsFromSignupResponse(oldPayments, signups) {
  const signupPayments = signups.reduce(
    (newGroups, signup) => newGroups.union(signup.payments || []),
    Immutable.Set(),
  )

  return signupPayments.reduce((newPayments, signupPayment) => {
    const newGroup = createPayment(signupPayment.payment)

    return replacePayment(newPayments, newGroup)
  }, oldPayments)
}

function replacePayment(payments, payment) {
  return payments
    .filter(search => search.reference !== payment.reference)
    .add(payment)
}

export default function reducer(state = initialState, action) {
  const { payload } = action

  switch (action.type) {
    case RECEIVE_SIGNUPS:
      return state.set('payments', buildPaymentsFromSignupResponse(state.get('payments'), payload.signups))

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/payment.js